import { EJNotifications } from '../../../cimsPage/instances/ej'
import { Notifications } from '../../common'

const { Edit, View } = Notifications({
  page: EJNotifications,
  view: '75A6924A-53A7-45C8-BB9D-0D556078D682',
  edit: '13BEE10B-7DAF-49BD-B63E-FD42EB5ADD3D',
})

export const ViewEJNotification = View
export const EditEJNotification = Edit

export type EJNotificationPermission =
  | typeof ViewEJNotification
  | typeof EditEJNotification
